var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvaliable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#41CF19",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4733 8.80657C16.4114 8.74409 16.3376 8.69449 16.2564 8.66065C16.1752 8.6268 16.088 8.60938 16 8.60938C15.912 8.60938 15.8249 8.6268 15.7436 8.66065C15.6624 8.69449 15.5886 8.74409 15.5267 8.80657L10.56 13.7799L8.47334 11.6866C8.40899 11.6244 8.33303 11.5755 8.2498 11.5427C8.16656 11.5099 8.07768 11.4938 7.98822 11.4954C7.89877 11.4969 7.8105 11.5161 7.72844 11.5518C7.64639 11.5874 7.57217 11.6389 7.51001 11.7032C7.44785 11.7676 7.39897 11.8435 7.36617 11.9268C7.33337 12.01 7.31728 12.0989 7.31883 12.1884C7.32038 12.2778 7.33953 12.3661 7.37519 12.4481C7.41085 12.5302 7.46233 12.6044 7.52667 12.6666L10.0867 15.2266C10.1486 15.2891 10.2224 15.3387 10.3036 15.3725C10.3849 15.4063 10.472 15.4238 10.56 15.4238C10.648 15.4238 10.7352 15.4063 10.8164 15.3725C10.8976 15.3387 10.9714 15.2891 11.0333 15.2266L16.4733 9.78657C16.541 9.72415 16.595 9.64838 16.632 9.56404C16.6689 9.47971 16.688 9.38864 16.688 9.29657C16.688 9.20451 16.6689 9.11344 16.632 9.0291C16.595 8.94477 16.541 8.869 16.4733 8.80657Z",
    fill: "#35B90D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliable);
export default __webpack_public_path__ + "static/media/avaliable.38f7d50677c3a86a09576dc81cc15444.svg";
export { ForwardRef as ReactComponent };